/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_ScreenshotsInputs */

const en_directory_detail_screenshots = /** @type {(inputs: Directory_Detail_ScreenshotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screenshots`)
};

const zh_directory_detail_screenshots = /** @type {(inputs: Directory_Detail_ScreenshotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品截图`)
};

/**
* | output |
* | --- |
* | "Screenshots" |
*
* @param {Directory_Detail_ScreenshotsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_screenshots = /** @type {((inputs?: Directory_Detail_ScreenshotsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_ScreenshotsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_screenshots(inputs)
	return zh_directory_detail_screenshots(inputs)
});
export { directory_detail_screenshots as "directory.detail.screenshots" }